import type {
  OrderListingStatus,
  OrderListingStatusCreateParams,
  OrderListingStatusUpdateParams,
} from '@/libs/interfaces'

import { mockOrderListingStatuses } from '../fixtures/orderListingStatuses'
import { delay, genID, nowISO } from '../helpers'
import { createEntityStore } from '../store'

const orderListingStatusStore = createEntityStore<OrderListingStatus, 'orderListingStatusID'>(
  mockOrderListingStatuses,
  'orderListingStatusID',
)

export const orderListingStatusesApiMock = {
  list: async (orgID: string, storeID: string): Promise<OrderListingStatus[]> =>
    delay(
      orderListingStatusStore.find(
        (status) => status.orgID === orgID && status.storeID === storeID,
      ),
    ),

  create: async (params: OrderListingStatusCreateParams): Promise<OrderListingStatus> => {
    const { orgID, storeID, name } = params
    const status: OrderListingStatus = {
      orderListingStatusID: genID('order-listing-status'),
      orgID,
      storeID,
      kanbanPosition: String(
        orderListingStatusStore.find((item) => item.storeID === storeID).length + 1,
      ),
      name,
      createdAt: nowISO(),
      updatedAt: nowISO(),
    }
    orderListingStatusStore.insert(status)
    return delay(status)
  },

  update: async (params: OrderListingStatusUpdateParams): Promise<OrderListingStatus> => {
    const { orderListingStatusID, name } = params
    const updated = orderListingStatusStore.update(orderListingStatusID, {
      ...(name !== undefined && { name }),
      updatedAt: nowISO(),
    })
    return delay(updated ?? ({} as OrderListingStatus))
  },

  delete: async (_orgID: string, _storeID: string, orderListingStatusID: string): Promise<void> => {
    orderListingStatusStore.remove(orderListingStatusID)
    await delay(undefined)
  },
}
